import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import ManageStats from "../../components/statistics/ManageStats";
import { RouteConstants } from "../../constants/RouteConstants";

class StatContainer extends Component {
  componentDidMount() {
    const { trackingHelper } = this.props.rootStore;
    trackingHelper.trackPageView(RouteConstants.STATISTICS.title);
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="col-12 p-0 mb-4">
          <ManageStats />
        </div>
      </div>
    );
  }
}

StatContainer.propTypes = {
  rootStore: PropTypes.object.isRequired
};

export default inject("rootStore")(observer(StatContainer));
